module.exports = __webpack_public_path__ + "img/main-slide-mobile-1.cfe60b73.jpeg";